var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.98 15.12c-1.66 3.76-3 6.86-2.98 6.92.08.2 5.7 6.52 5.8 6.48.04-.02 1.86-1.94 4.02-4.24l3.94-4.22-.78-1.2c-3-4.56-6.8-10.36-6.9-10.46-.08-.08-.84 1.58-3.1 6.72zM35.9 15.36c-.74.14-1.68.68-3.58 2.02l-1.74 1.22v1.24c0 1.22 0 1.24-.26 1.44-.28.22-.54.18-.8-.1-.14-.16-.18-.36-.18-.94v-.76l-.38.3-.38.3v1.48c0 1.32-.02 1.5-.16 1.64-.34.32-.9.14-1-.34-.02-.12-.06-.58-.08-1.02l-.02-.82-.5.28-.5.3v1.58c0 1.46-.02 1.6-.18 1.76-.26.22-.66.2-.86-.04-.14-.18-.16-.4-.16-1.5v-1.3l-.5.14c-.28.08-.94.14-1.5.14-.94 0-1.12-.02-3.16-.58-2.32-.62-2.86-.7-3.12-.42-.64.66-8 9.12-8.02 9.22-.02.06.8 1.66 1.8 3.54l1.84 3.44 3.28 2.62c1.82 1.44 3.32 2.62 3.36 2.62.06 0 4.6-4.92 4.72-5.16.04-.08-.3-.56-.96-1.32-1.28-1.48-1.28-1.52-.5-2.26.3-.28.66-.58.82-.66a27.7 27.7 0 0 1 2.9-.58l2.6-.44 5.8-6.36c3.18-3.5 5.84-6.46 5.9-6.58s.14-.46.18-.76c.08-.84-.2-1.52-1-2.3a3.33 3.33 0 0 0-1.18-.84 5.47 5.47 0 0 0-2.48-.2zM44.6 18.38a695.6 695.6 0 0 0-13.08 14.24c-.26.52-.1.84.96 1.82 2.64 2.44 2.76 2.5 3.38 2.18.44-.22 13.1-14 13.26-14.44.2-.56.06-.76-1.44-2.16a36.17 36.17 0 0 0-1.78-1.58c-.44-.3-.94-.34-1.3-.06zM43.76 29.96c-.1.02-.8.76-1.58 1.62-1.04 1.16-1.4 1.62-1.42 1.8 0 .2.32.5 2.12 1.9 2.12 1.66 2.5 1.88 2.64 1.52.08-.18.06-2.38-.02-4.24-.08-1.6-.06-1.58-.9-2.3-.46-.38-.54-.42-.84-.3z"
  })));
});